import React, { useEffect, useState } from 'react'
import {
  StyleSearchConversationWrapper,
  StyleSearchIconWrapper,
  StyleSearchInput,
} from '../style'
import { Search } from 'lucide-react'
import theme from '@utils/theme'
import { useDispatch, useSelector } from 'react-redux'
import { Actions, RootState } from '@store/index'
import { useLocation, useNavigate } from 'react-router-dom'
import ConversationLists from '../lists'
import useIsMobile from '@hooks/useIsMobile'
import useDebounce from '@hooks/useDebounce'

const ConversationLayout = () => {
  const selectedChat = useSelector((state: RootState) => state.selectedChat)
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  // Sample conversation data
  const conversations = [
    {
      name: 'Alice Johnson',
      avatar: 'https://i.pravatar.cc/150?img=1',
      role: 'Students',
      latestMessage: 'See you tomorrow!',
      time: '5m',
      isNewMessageReceived: true,
    },
    {
      name: 'Bikash Shrestha',
      avatar: 'https://i.pravatar.cc/150?img=2',
      role: 'Agency',
      latestMessage: 'Can we schedule a call?',
      time: '15m',
      isNewMessageReceived: false,
    },
    {
      name: 'Carlos Mendes',
      avatar: 'https://i.pravatar.cc/150?img=3',
      role: 'Counsellor',
      latestMessage: 'Got it, thanks!',
      time: '2h',
      isNewMessageReceived: true,
    },
    {
      name: 'Deepa Rani',
      avatar: 'https://i.pravatar.cc/150?img=4',
      role: 'Admin',
      latestMessage: 'Approved your request.',
      time: '1d',
      isNewMessageReceived: false,
    },
    {
      name: 'Ethan Clarke',
      avatar: 'https://i.pravatar.cc/150?img=5',
      role: 'Students',
      latestMessage: 'Looking forward to it!',
      time: '8h',
      isNewMessageReceived: false,
    },
    {
      name: 'Fatima Al-Hassan',
      avatar: 'https://i.pravatar.cc/150?img=6',
      role: 'Agency',
      latestMessage: 'Thanks for the update.',
      time: '3h',
      isNewMessageReceived: true,
    },
    {
      name: 'Gopal Lama',
      avatar: 'https://i.pravatar.cc/150?img=7',
      role: 'Counsellor',
      latestMessage: 'Please send the document.',
      time: '10m',
      isNewMessageReceived: false,
    },
    {
      name: 'Hiro Tanaka',
      avatar: 'https://i.pravatar.cc/150?img=8',
      role: 'Admin',
      latestMessage: 'Meeting rescheduled.',
      time: '1h',
      isNewMessageReceived: true,
    },
    {
      name: 'Ivy Chen',
      avatar: 'https://i.pravatar.cc/150?img=9',
      role: 'Students',
      latestMessage: 'Done with the task.',
      time: '6h',
      isNewMessageReceived: false,
    },
    {
      name: 'Jacob Müller',
      avatar: 'https://i.pravatar.cc/150?img=10',
      role: 'Admin',
      latestMessage: 'Let’s connect soon.',
      time: '30m',
      isNewMessageReceived: true,
    },
  ]

  useEffect(() => {
    dispatch(Actions.reset('selectedChat'))

    const basePath = location.pathname.split('/').slice(0, 3).join('/')
    if (location.pathname !== basePath) {
      navigate(basePath, { replace: true })
    }
  }, [])

  const [searchInput, setSearchInput] = useState('')
  const debouncedValue = useDebounce(searchInput, 500)

  const filteredData = conversations.filter((d) =>
    d.name.toLowerCase().includes(debouncedValue.toLowerCase()),
  )

  return (
    <>
      {/* Show search only on large screen OR on mobile when no chat selected */}
      {(!isMobile || (isMobile && !selectedChat)) && (
        <>
          <StyleSearchConversationWrapper>
            <StyleSearchInput
              placeholder="Search Conversation"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <StyleSearchIconWrapper>
              <Search width={20} color={theme.colors.placeholder} />
            </StyleSearchIconWrapper>
          </StyleSearchConversationWrapper>

          <ConversationLists title={''} data={filteredData} />
        </>
      )}
    </>
  )
}

export default ConversationLayout
